<template>
  <header class="header">
    <div class="header-top">
      <div class="container">
        <div class="header-top-content">
          <div class="top-left">
            您好，欢迎来到秦土智配平台
          </div>
          <div class="login-links">
            <!-- 根据登录状态显示不同内容 -->
            <template v-if="!isLoggedIn">
              <a href="#" class="login-link" @click.prevent="showLoginDialog">登录</a>            
              <a href="#" class="login-link" @click.prevent="showRegisterDialog">注册</a>
              <!-- <a href="#" class="login-link publish-btn" @click.prevent="showLoginDialog">免费发布土方
                <span class="iconfont icon-xiangyou3"></span>
              </a> -->
            </template>
            <template v-else >
              <div style="display: flex; align-items: center;">
                 <!-- 已登录状态显示 -->
              <div 
                class="user-info-wrapper"
                @click.stop="toggleUserDropdown"
              >
                <span class="user-info">
                  <span class="user-name">{{ userInfo.companyName || '用户' }}</span>
                  <span class="user-phone" v-if="userInfo.phonenumber">{{ maskedPhone }}</span>
                  <span class="iconfont icon-xiangyou3 dropdown-arrow" :class="{ 'arrow-up': showUserDropdown }"></span>
              
                </span>
                
                <div 
                  class="user-dropdown" 
                  v-show="showUserDropdown"
                >
                  <div class="user-dropdown-item" @click="goToUserProfile">
                    <i class="iconfont icon-guanlian"></i>
                    个人中心
                  </div>
                  <div class="user-dropdown-item" @click="goToAdmin" v-if="userInfo.userType === '00'">
                    <i class="iconfont icon-fabuxinxi"></i>
                    后台管理
                  </div>
                  <div class="user-dropdown-item" @click="handleLogout">
                    <i class="iconfont icon-shanchu"></i>
                    退出登录
                  </div>
                </div>
              </div>
                  <span class="notice-icon-wrapper" @click="goToNoticeList" title="系统通知">
                    <span class="iconfont icon-bell notice-icon"></span>
                    <span v-if="unreadCount > 0" class="notice-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
                  </span>
              </div>
            
            </template>
          </div>
        </div>
      </div>
    </div>
    
    <div class="header-main">
      <div class="container">
        <div class="header-main-content">
        
           <div class="logo">
            <span class="logo-text2"><img src="@/assets/logo1.png" alt="秦土智配" class="logo1"></span>
            <span class="logo-text1">以智驭土，平衡有道</span>
          </div>
          <div class="logo-text">
            <img src="@/assets/logo2.png" alt="助力节能增效，助推绿色发展" class="logo2">
            <!-- <span class="logo-text3">城乡建设土平衡，秦土智配智先行</span>  -->
          </div>
       
          <!-- 搜索栏 -->
          <div class="search-section">
            <div class="search-bar">
              <div class="search-bar-left">
                <span class="search-dropdown">
                找土方
                </span>
                <div class="search-input-group">
                  <span class="iconfont icon-sousuo"></span>
                  <input 
                    type="text" 
                    v-model="searchKeyword"
                    placeholder="输入土方关键词,例如,砂砾坚土"
                    class="search-input"
                  />
                  <button class="search-btn" @click="goToSearch">搜索</button>
                </div>
              </div>
              
              <button class="post-btn" @click="goToPublish">免费发布土方</button>
            </div>
            
            <div class="search-keywords">
              <span class="keyword" @click="fillKeyword('松软土')">松软土</span>
              <span class="keyword" @click="fillKeyword('普通土')">普通土</span>
              <span class="keyword" @click="fillKeyword('表土')">表土</span>
              <span class="keyword" @click="fillKeyword('坚土')">坚土</span>
              <span class="keyword" @click="fillKeyword('回填土方')">回填土方</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 主导航菜单 -->
    <nav class="main-nav">
      <div class="container">
        <ul class="nav-list">
          <li class="nav-item" :class="{ active: activePage === 'home' }" @click="switchPage('home')">首页</li>
          <li class="nav-item" :class="{ active: activePage === 'search' }" @click="switchPage('search')">我要找土</li>
          <li class="nav-item" :class="{ active: activePage === 'abandon' }" @click="switchPage('abandon')">我要弃土</li>
          <li class="nav-item" :class="{ active: activePage === 'success' }" @click="switchPage('success')">成功案例</li>
          <!-- <li class="nav-item" :class="{ active: activePage === 'transport' }" @click="switchPage('transport')">运输</li> -->
          <li class="nav-item" :class="{ active: activePage === 'service' }" @click="switchPage('service')">企业之家</li>
          <!-- <li class="nav-item" :class="{ active: activePage === 'farm' }" @click="switchPage('farm')">农交网</li>
          <li class="nav-item" :class="{ active: activePage === 'carbon' }" @click="switchPage('carbon')">碳交易</li> -->
          <li class="nav-item" :class="{ active: activePage === 'news' }" @click="switchPage('news')">水保资讯</li>
          <li class="nav-item" :class="{ active: activePage === 'faw' }" @click="switchPage('faw')">法律法规</li>
          <li class="nav-item" :class="{ active: activePage === 'contact' }" @click="switchPage('contact')">技术规范</li>
          <li class="nav-item nav-dropdown">
            <span>相关链接</span>
            <ul class="dropdown-menu">
              <li class="dropdown-item">
                <a href="http://swcc.mwr.gov.cn/" target="_blank">水土保持司</a>
              </li>
              <!-- <li class="dropdown-item">
                <a href="https://cnscm.mwr.cn/" target="_blank"></a>
              </li> -->
              <li class="dropdown-item">
                <a href="http://www.swcc.org.cn/" target="_blank">水土保持生态环境建设网</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>

  <!-- 成功提示框（登录/退出等复用） -->
  <transition name="toast-fade">
    <div v-if="showSuccessToast" class="success-toast">
      <div class="toast-content">
        <span class="toast-icon">✓</span>
        <span class="toast-message">{{ successToastMessage }}</span>
      </div>
    </div>
  </transition>

  <!-- 右侧固定边栏 -->
  <div class="fixed-sidebar">
 
   
    <div class="fixed-item" @click="showAICustomerService">
      <span class="fixed-icon iconfont icon-xiaoxi"></span>
      <span class="fixed-text">在线咨询</span>
    </div>
    <div class="fixed-item contact-item">
      <span class="fixed-icon iconfont icon-ziyuan"></span>
      <span class="fixed-text">联系方式</span>
      <!-- 二维码悬停面板 -->
      <div class="contact-qr-panel">
       
        <div class="qr-panel-body">
          <div class="qr-code-wrapper">
            <img src="@/assets/images/qtzp-ma.png" alt="联系方式二维码" class="qr-code-image" />
          </div>
          <!-- <div class="qr-panel-tip">扫描二维码获取联系方式</div> -->
        </div>
      </div>
    </div>
    <div class="fixed-item back-top" @click="scrollToTop">
      <span class="fixed-icon iconfont icon-fanhuidingbu-"></span>
      <span class="fixed-text">返回顶部</span>
    </div>
    
  </div>

  <!-- AI客服弹窗 -->
  <div class="dialog" :class="{ 'dialog-show': showDialog }" @click="closeDialog">
    <div class="dialog-content" @click.stop>
      <div class="dialog-header">
        <h3 class="dialog-title">AI智能客服</h3>
        <button class="dialog-close" @click="closeDialog">×</button>
      </div>
      <div class="dialog-body">
        <div class="chat-messages">
          <div class="message ai-message" v-for="(message, index) in chatMessages" :key="index" :class="{ 'user-message': message.type === 'user' }">
            <div class="message-avatar">
              <span class="iconfont icon-AIkefu" v-if="message.type === 'ai'"></span>
              <span class="iconfont icon-kehu" v-else></span>
            </div>
            <div class="message-content">
              <p>{{ message.content }}</p>
            </div>
          </div>
        </div>
        <div class="chat-input">
          <input 
            type="text" 
            placeholder="请输入您的问题..." 
            class="input-field"
            v-model="userInput"
            @keyup.enter="sendMessage"
          />
          <button class="send-btn" @click="sendMessage">发送</button>
        </div>
      </div>
    </div>
  </div>

  <!-- 登录弹窗 -->
  <div class="login-modal" :class="{ 'modal-show': showLoginModal }" @click.self="closeLoginModal">
    <div class="login-modal-content">
          <div class="modal-header">
            <h3 class="modal-title">用户登录</h3>
            <button class="modal-close" @click="closeLoginModal">×</button>
          </div>
          
          <div class="modal-body">
            <!-- 登录表单 -->
            <form @submit.prevent="handleLogin" class="auth-form">
              <div class="form-group">
                <label class="form-label">手机号/邮箱</label>
                <input 
                  type="text" 
                  class="form-input" 
                  v-model="loginForm.username"
                  placeholder="请输入手机号或邮箱"
                  required
                />
              </div>
              
              <div class="form-group">
                <label class="form-label">密码</label>
                <input 
                  type="password" 
                  class="form-input" 
                  v-model="loginForm.password"
                  placeholder="请输入密码"
                  required
                />
              </div>

              <div class="form-group">
                <label class="form-label">验证码</label>
                <div class="verification-group">
                  <input 
                    type="text" 
                    class="form-input verification-input" 
                    v-model="loginForm.code"
                    placeholder="请输入验证码"
                    required
                  />
                  <img 
                    v-if="loginCaptcha.img"
                    :src="loginCaptcha.img"
                    alt="验证码"
                    class="captcha-img"
                    @click="fetchLoginCaptcha"
                    title="点击刷新"
                  />
                  <button type="button" class="verification-btn" @click="fetchLoginCaptcha">刷新</button>
                </div>
              </div>
              
              <div class="form-options">
                <label class="checkbox-label">
                  <input type="checkbox" v-model="loginForm.remember">
                  <span class="checkmark"></span>
                  记住密码
                </label>
                <!-- <a href="#" class="forgot-link">忘记密码？</a> -->
              </div>
              
              <button type="submit" class="auth-btn">登录</button>
              <button type="button" class="auth-btn" style="background-color: #fff; color: #422C27; border: 1px solid #422C27; margin-top: 10px;" @click="showRegisterDialog">注册账号</button>
            </form>
          </div>
        </div>
      </div>
      
      <!-- 注册弹窗 -->
      <div class="register-modal" :class="{ 'modal-show': showRegisterModal }" @click.self="closeRegisterModal">
        <div class="register-modal-content">
          <div class="modal-header">
            <h3 class="modal-title">用户注册</h3>
            <button class="modal-close" @click="closeRegisterModal">×</button>
          </div>
          
          <div class="modal-body">
            <!-- 注册表单 -->
            <form @submit.prevent="handleRegister" class="auth-form" autocomplete="off" novalidate>
          <!-- 第一行：手机号和验证码 -->
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">手机号</label>
              <input 
                type="tel" 
                class="form-input" 
                v-model="registerForm.phone"
                name="reg-phone"
                autocomplete="off"
                inputmode="numeric"
                placeholder="请输入手机号"
                required
              />
            </div>
            
            <div class="form-group">
              <label class="form-label">验证码</label>
              <div class="verification-group">
                <input 
                  type="text" 
                  class="form-input verification-input" 
                  v-model="registerForm.code"
                  name="reg-sms-code"
                  autocomplete="off"
                  placeholder="请输入验证码"
                  required
                />
                <button type="button" class="verification-btn" @click="sendVerificationCode">获取验证码</button>
              </div>
            </div>
          </div>
          
          <!-- 第二行：密码和确认密码 -->
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">密码</label>
              <input 
                type="password" 
                class="form-input" 
                v-model="registerForm.password"
                name="reg-password"
                autocomplete="new-password"
                placeholder="请输入密码"
                required
              />
            </div>
            
            <div class="form-group">
              <label class="form-label">确认密码</label>
              <input 
                type="password" 
                class="form-input" 
                v-model="registerForm.confirmPassword"
                name="reg-confirm-password"
                autocomplete="new-password"
                placeholder="请再次输入密码"
                required
              />
            </div>
          </div>

              <!-- 公司名称 -->
              <div class="form-group">
                <label class="form-label">公司名称</label>
                <input 
                  type="text"
                  class="form-input"
                  v-model="registerForm.companyName"
                  name="reg-company-name"
                  autocomplete="off"
                  placeholder="请输入公司名称"
                />
              </div>
          
         
          
          <!-- 第三行：立项文件和法人身份证 -->
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">上传立项文件</label>
              <span class="form-require">注册成功后，该账号有限期为2年</span>
              <div class="file-upload">
                <input 
                  type="file" 
                  id="projectFile"
                  ref="projectFileInput"
                  @change="handleFileUpload('projectFile', $event)"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                />
                <label for="projectFile" class="file-upload-label">
                  <span class="iconfont icon-upload"></span>
                  {{ registerForm.projectFile ? registerForm.projectFile.name : '点击上传立项文件' }}
                </label>
              </div>
              <!-- 图片预览 -->
              <div v-if="registerForm.projectFilePreview" class="image-preview">
                <img :src="registerForm.projectFilePreview" alt="立项文件预览" class="preview-image">
                <button type="button" class="remove-image-btn" @click="removeFile('projectFile')">
                 <span class="iconfont icon-shanchu"></span>
                </button>
              </div>
            </div>
            
            <div class="form-group">
              <label class="form-label">法人身份证</label>
               <span class="form-require">请上传人像面</span>
              <div class="file-upload">
                <input 
                  type="file" 
                  id="legalId"
                  ref="legalIdInput"
                  @change="handleFileUpload('legalId', $event)"
                  accept=".pdf,.jpg,.jpeg,.png"
                />
                <label for="legalId" class="file-upload-label">
                  <span class="iconfont icon-upload"></span>
                  {{ registerForm.legalId ? registerForm.legalId.name : '点击上传法人身份证' }}
                </label>
              </div>
              <!-- 图片预览 -->
              <div v-if="registerForm.legalIdPreview" class="image-preview">
                <img :src="registerForm.legalIdPreview" alt="法人身份证预览" class="preview-image">
                <button type="button" class="remove-image-btn" @click="removeFile('legalId')">
                  <span class="iconfont icon-shanchu"></span>
                </button>
              </div>
            </div>
          </div>
          
          <!-- 第四行：营业执照 -->
          <div class="form-group">
              <label class="form-label">营业执照</label>
              <div class="file-upload">
                <input 
                  type="file" 
                  id="businessLicense"
                  ref="businessLicenseInput"
                  @change="handleFileUpload('businessLicense', $event)"
                  accept=".pdf,.jpg,.jpeg,.png"
                />
                <label for="businessLicense" class="file-upload-label">
                  <span class="iconfont icon-upload"></span>
                  {{ registerForm.businessLicense ? registerForm.businessLicense.name : '点击上传营业执照' }}
                </label>
              </div>
              <!-- 图片预览 -->
              <div v-if="registerForm.businessLicensePreview" class="image-preview">
                <img :src="registerForm.businessLicensePreview" alt="营业执照预览" class="preview-image">
                <button type="button" class="remove-image-btn" @click="removeFile('businessLicense')">
                  <span class="iconfont icon-shanchu"></span>
                </button>
              </div>
            </div>
          
          <div class="form-options">
            <label class="checkbox-label">
              <input type="checkbox" v-model="registerForm.agree">
              <span class="checkmark"></span>
              我已阅读并同意<a href="#" class="agreement-link">《用户协议》</a>和<a href="#" class="agreement-link">《隐私政策》</a>
            </label>
          </div>
          
          <button type="submit"  class="auth-btn">注册</button>
          <!-- <button type="button" class="auth-btn" @click.prevent="showLoginDialog">登录</button> -->
        </form>
      </div>
    </div>
  </div>

  <!-- 发布土方弹窗 -->
  <div v-if="showPublishModal" class="publish-modal" @click.self="closePublishModal">
    <div class="publish-modal-container">
      <div class="publish-modal-header">
        <h3>发布土方信息</h3>
        <button class="modal-close" @click="closePublishModal">×</button>
      </div>
      <div class="publish-modal-content">
        <Publish :val="0" @close="closePublishModal" />
      </div>
    </div>
  </div>

  <!-- 联系电话图片弹窗 -->
  <div class="contact-image-modal" :class="{ 'modal-show': showContactImageModal }" @click.self="closeContactImageModal">
    <div class="contact-image-modal-content">
      <div class="contact-image-header">
        <h3 class="contact-image-title">联系电话</h3>
        <button class="modal-close" @click="closeContactImageModal">×</button>
      </div>
      <div class="contact-image-body">
        <img src="@/assets/images/ma.jpg" alt="联系电话" class="contact-image" />
      </div>
    </div>
  </div>
</template>

<script>
import Publish from './publish.vue'
import { login, register, getSmsCode, uploadFile, getUserInfo, getLoginCode, logout, getUnreadCount } from '@/api'

export default {
  name: "TopHeader",
  components: {
    Publish
  },
  props: {
    currentPage: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      // 搜索关键词
      searchKeyword: '',
      // 登录状态变量
      isLoggedIn: false,
      // 土方平台权限状态
      isSoil: true,
      // 用户信息
      userInfo: {},
      // 用户下拉菜单显示状态
      showUserDropdown: false,
      // 未读通知数量
      unreadCount: 0,
      // storage 事件监听器引用
      storageListener: null,
      // 登录弹窗相关数据
      showLoginModal: false,
      loginForm: {
        username: '',
        password: '',
        code: '',
        remember: false
      },
      // 登录验证码
      loginCaptcha: {
        img: '',
        uuid: ''
      },
      // 注册弹窗相关数据
      showRegisterModal: false,
      // 发布土方弹窗相关数据
      showPublishModal: false,
      // 联系电话图片弹窗
      showContactImageModal: false,
      registerForm: {
        phone: '',
        code: '',
        password: '',
        confirmPassword: '',
        agree: false,
        projectFile: null,
        legalId: null,
        businessLicense: null,
        userPhone: '',
        projectFilePreview: '',
        legalIdPreview: '',
        businessLicensePreview: '',
        // 文件上传后的URL
        projectFileUrl: '',
        legalIdUrl: '',
        businessLicenseUrl: '',
        companyName: ''
      },
      
      // AI客服相关数据
      showDialog: false,
      // 登录成功提示
      showSuccessToast: false,
      successToastMessage: '',
      userInput: '',
      chatMessages: [
        {
          type: 'ai',
          content: '您好！我是秦土平台的AI智能客服，有什么可以帮助您的吗？'
        }
      ]
    }
  },
  computed: {
    // 根据当前路由动态计算选中状态
    activePage() {
      const route = this.$route.path;
      const from = this.$route.query && this.$route.query.from;
      if (route === '/') {
        return 'home';
      } else if (route === '/findlist') {
        return 'search'; // 找土页面
      } else if (route === '/qilist') {
        return 'abandon'; // 弃土页面
      } else if (route.startsWith('/zixun')) {
        return 'news'; // 资讯详情页对应"土资讯"
      } else if (route.startsWith('/product')) {
        // 详情页根据来源决定选中项
        if (from === 'abandon') return 'abandon';
        if (from === 'service') return 'service';
        if (from === 'success') return 'success'; // 从成功案例进入
        return 'search'; // 默认按找土
      } else if (route === '/topSearch') {
        return 'search'; // 搜索页面对应"找土"
      } else if (route === '/serveList') {
        return 'service'; // 服务中心页面
      } else if (route === '/faw' || route.startsWith('/fawDetail')) {
        return 'faw'; // 法律法规页面及详情页
      } else if (route === '/transport') {
        return 'transport'; // 运输页面
      } else if (route === '/techSpec' || route.startsWith('/techSpecDetail')) {
        return 'contact'; // 技术规范页面及详情页
      } else if (route === '/success') {
        return 'success'; // 成功案例页面
      } 
      return this.currentPage;
    },
    // 加密显示手机号（如 173****2749）
    maskedPhone() {
      const p = this.userInfo && this.userInfo.phonenumber ? String(this.userInfo.phonenumber) : '';
      if (!p) return '';
      // 仅对 >=7 位进行简单掩码；常见 11 位手机：3+4+4
      if (p.length >= 7) {
        const start = p.slice(0, 3);
        const end = p.slice(-4);
        return `${start}****${end}`;
      }
      // 其他长度，保留首尾，掩中间
      if (p.length > 2) {
        return p[0] + '*'.repeat(Math.max(1, p.length - 2)) + p[p.length - 1];
      }
      // 太短则直接返回
      return p;
    }
  },
  methods: {
    // 检查土方平台权限
    checkSoilPermission() {
      // 如果已登录但 isSoil 为 false，显示发布土方弹窗
      if (this.isLoggedIn && this.isSoil === false) {
        this.showPublishModal = true;
        return false; // 返回 false 表示没有权限，阻止原操作
      }
      return true; // 返回 true 表示有权限，继续执行
    },
    goToAdmin() {
      // 后台管理不受 isSoil 影响，只要登录即可访问
      window.open('https://qtzp.qhdbigdata.com/qtzp-web/login', '_blank');
    },
    // 获取登录验证码
    async fetchLoginCaptcha() {
      try {
        const res = await getLoginCode();
        // 常见返回：{ img: 'data:image/png;base64,...', uuid: '...' }
        if (res && (res.img || res.data?.img)) {
          const rawImg = res.img || res.data.img;
          const uuid = res.uuid || res.data.uuid;

          // 如果后端返回纯base64字符串（无data:image/*;base64, 前缀），则补齐前缀
          const hasDataUrlPrefix = /^data:image\/(png|jpeg|jpg|gif);base64,/i.test(rawImg);
          // 尝试从返回中判断mime类型，默认使用image/png
          const mimeGuess = (res.type || res.mime || res.data?.type || 'image/png').toString().toLowerCase();
          const mime = /image\//.test(mimeGuess) ? mimeGuess : `image/${mimeGuess}`;
          const dataUrl = hasDataUrlPrefix ? rawImg : `data:${mime};base64,${rawImg}`;

          this.loginCaptcha = {
            img: dataUrl,
            uuid
          };
        }
      } catch (e) {
        console.error('获取验证码失败', e);
      }
    },
    goToPublish() {
      // 检查登录状态
      if (!this.isLoggedIn) {
        // 未登录，显示登录弹窗
        this.showLoginDialog();
        return;
      }
      // 检查土方平台权限
      if (!this.checkSoilPermission()) {
        return;
      }
      // 已登录且有权限，打开发布弹窗
      this.showPublishModal = true;
    },
    closePublishModal() {
      this.showPublishModal = false;
    },
    // 显示联系电话图片
    goToServiceList() {
        this.showContactImageModal = true;
    },
    // 关闭联系电话图片弹窗
    closeContactImageModal() {
        this.showContactImageModal = false;
    },
    // 显示登录弹窗
    showLoginDialog() {
      this.showLoginModal = true;
      this.fetchLoginCaptcha();
    },
    
    // 显示注册弹窗
    showRegisterDialog() {
      this.showRegisterModal = true;
    },
    
    // 关闭登录弹窗
    closeLoginModal() {
      this.showLoginModal = false;
      this.resetLoginForm();
    },
    
    // 关闭注册弹窗
    closeRegisterModal() {
      this.showRegisterModal = false;
      this.resetRegisterForm();
    },
    
    // 重置登录表单
    resetLoginForm() {
      this.loginForm = {
        username: '',
        password: '',
        code: '',
        remember: false
      };
    },
    
    // 重置注册表单
    resetRegisterForm() {
      this.registerForm = {
        phone: '',
        code: '',
        password: '',
        confirmPassword: '',
        agree: false,
        projectFile: null,
        legalId: null,
        businessLicense: null,
        userPhone: '',
        projectFilePreview: '',
        legalIdPreview: '',
        businessLicensePreview: '',
        // 文件上传后的URL
        projectFileUrl: '',
        legalIdUrl: '',
        businessLicenseUrl: '',
        companyName: ''
      };
    },
    
    // 跳转到搜索页面
    // 填充关键词到搜索框
    fillKeyword(keyword) {
      this.searchKeyword = keyword
    },
    
    goToSearch() {
      // 如果有搜索关键词，传递到搜索页面
      if (this.searchKeyword && this.searchKeyword.trim()) {
        this.$router.push({
          path: '/findlist',
          query: { keyword: this.searchKeyword.trim() }
        });
      } else {
        this.$router.push('/findlist');
      }
    },
    
    // 切换页面
    switchPage(page) {
      console.log(this.isSoil,'isSoil-----------------');
      if (page === 'home') {
        // 点击首页时跳转到根路径，显示QintuPlatform组件
        this.$router.push('/');
      } else if (page === 'search') {
        // 点击找土时检查权限
        if (this.isLoggedIn && this.isSoil === false) {
          this.showPublishModal = true;
          return;
        }
        this.$router.push('/findlist');
      } else if (page === 'abandon') {
        // 点击弃土时检查权限
        if (this.isLoggedIn && this.isSoil === false) {
          this.showPublishModal = true;
          return;
        }
        this.$router.push('/qilist');
      } else if (page === 'news') {
        // 点击土资讯时跳转到资讯列表页面
        this.$router.push('/zixunlist');
      } else if (page === 'service') {
        // 点击服务中心时跳转到服务列表页面
        this.$router.push('/serveList');
      } else if (page === 'faw') {
        // 点击法律法规时跳转到法律法规页面
        this.$router.push('/faw');
      } else if (page === 'transport') {
        // 点击运输时跳转到运输页面
        this.$router.push('/transport');
      } else if (page === 'contact') {
        // 点击技术规范时跳转到技术规范页面
        this.$router.push('/techSpec');
      } 
      else if (page === 'success') {
        // 点击成功案例时检查权限
        if (this.isLoggedIn && this.isSoil === false) {
          this.showPublishModal = true;
          return;
        }
        this.$router.push('/success');
      }
      else {
        // 其他页面保持原有逻辑
        this.$emit('page-change', page);
      }
    },
    
    // 处理登录
    async handleLogin() {
      try {
        const res = await login({
          username: this.loginForm.username,
          password: this.loginForm.password,
          code: this.loginForm.code,
          uuid: this.loginCaptcha.uuid
        });
        
        // 获取 isSoil 字段（默认为 true，如果接口没有返回该字段）
        const isSoil = res?.isSoil ?? res?.data?.isSoil ?? true;
        
        // 登录成功，保存token和登录状态
        if (res && (res.token || res.data?.token)) {
          const token = res.token || res.data.token
          localStorage.setItem('token', token);
        }
        
        // 保存 isSoil 状态
        this.isSoil = isSoil;
        localStorage.setItem('isSoil', String(isSoil));
        
        // 正常设置登录状态（无论 isSoil 是什么值）
        localStorage.setItem('isLoggedIn', 'true');
        this.isLoggedIn = true;
        
        // 同时尝试调用window上的方法（如果存在）
        if (window.updateQintuLoginStatus) {
          window.updateQintuLoginStatus(true);
        }
        
        // 加载用户信息
        await this.loadUserInfo();
        
        // 获取未读通知数量
        this.loadUnreadCount();
        
        // 关闭登录弹窗
        this.showLoginModal = false;
        this.resetLoginForm();
        
        // 显示登录成功提示（自动消失）
        this.successToastMessage = '登录成功';
        this.showSuccessToast = true;
        setTimeout(() => {
          this.showSuccessToast = false;
        }, 2000); // 2秒后自动消失
        
        // 简化重定向逻辑，优先使用保存的路径，否则保持当前页面
        try {
          const redirectPath = localStorage.getItem('redirectPath');
          if (redirectPath) {
            // 清除保存的路径
            localStorage.removeItem('redirectPath');
            // 使用setTimeout确保弹窗先关闭再执行路由跳转
            setTimeout(() => {
              this.$router.push(redirectPath).catch(error => {
                console.log('路由跳转失败，保持当前页面:', error);
              });
            }, 100);
          }
        } catch (error) {
          console.log('登录后处理失败:', error);
        }
      } catch (error) {
        console.error('登录失败:', error);
        
        // 提取接口返回的错误信息
        let errorMessage = '登录失败';
        
        if (error.response && error.response.data) {
          // 优先使用接口返回的错误信息
          const responseData = error.response.data;
          errorMessage = responseData.msg || responseData.message || responseData.error || errorMessage;
        } else if (error.message) {
          // 其次使用错误对象的 message
          errorMessage = error.message;
        } else {
          // 最后使用默认错误信息
          errorMessage = '用户名或密码错误';
        }
        
        alert(errorMessage);
      }
    },
    
    // 处理注册
    async handleRegister() {
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        alert('两次输入的密码不一致');
        return;
      }
      if (!this.registerForm.agree) {
        alert('请先同意用户协议和隐私政策');
        return;
      }
      
      // 检查必需的文件是否已上传
      if (!this.registerForm.projectFileUrl) {
        alert('请上传立项文件');
        return;
      }
      if (!this.registerForm.legalIdUrl) {
        alert('请上传法人身份证');
        return;
      }
      if (!this.registerForm.businessLicenseUrl) {
        alert('请上传营业执照');
        return;
      }
      
      try {
        // 使用已上传的文件URL进行注册
        await register({
          phoneNumber: this.registerForm.phone,
          smsCode: this.registerForm.code,
          password: this.registerForm.password,
          confirmPassword: this.registerForm.confirmPassword,
          projApprovalFileUrl: this.registerForm.projectFileUrl, // 只传fileName
          idCardUrl: this.registerForm.legalIdUrl, // 只传fileName
          businessLicenseUrl: this.registerForm.businessLicenseUrl, // 只传fileName
          companyName: this.registerForm.companyName
        });
        
        alert('提交成功！审核将在 1-3 个工作日内完成，请稍后登录查看。');
        this.closeRegisterModal();
      } catch (error) {
        console.error('注册失败:', error);
        alert('注册失败：' + (error.message || '未知错误'));
      }
    },
    
    // 发送验证码
    async sendVerificationCode() {
      if (!this.registerForm.phone) {
        alert('请先输入手机号');
        return;
      }
      
      try {
        await getSmsCode({
          phone: this.registerForm.phone
        });
        alert('验证码已发送');
      } catch (error) {
        console.error('发送验证码失败:', error);
        alert('发送验证码失败：' + (error.message || '未知错误'));
      }
    },
    
    // 设置认证模式（已移除，因为弹窗已分离）
    setAuthMode() {
      // 保留此方法以避免引用错误，移除了未使用的login参数
    },
    
    // 移除已上传的文件
    removeFile(field) {
      this.registerForm[field] = null;
      this.registerForm[`${field}Preview`] = '';
      // 清除文件URL
      if (field === 'projectFile') {
        this.registerForm.projectFileUrl = '';
      } else if (field === 'legalId') {
        this.registerForm.legalIdUrl = '';
      } else if (field === 'businessLicense') {
        this.registerForm.businessLicenseUrl = '';
      }
      // 重置input，以便可以再次选择同一文件
      if (this.$refs[`${field}Input`]) {
        this.$refs[`${field}Input`].value = '';
      }
    },
    
    // 处理文件上传并添加图片回显
    async handleFileUpload(field, event) {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        this.registerForm[field] = file;
        
        // 文件字段名称映射
        const fieldNames = {
          projectFile: '立项文件',
          legalId: '法人身份证',
          businessLicense: '营业执照'
        };
        
        // 立即上传文件
        try {
          const formData = new FormData();
          formData.append('file', file);
          
          // 显示上传中提示
          const uploadingMessage = `${fieldNames[field] || '文件'}上传中...`;
          console.log(uploadingMessage);
          
          const res = await uploadFile(formData);
          // 获取fileName（后端返回可能是 res.fileName, res.data.fileName 等）
          let fileName = '';
          if (typeof res === 'string') {
            fileName = res;
          } else if (res && typeof res === 'object') {
            fileName = res.fileName || (res.data && res.data.fileName) || res.url || (res.data && res.data.url) || '';
          }
          
          // 拼接完整路径用于回显
          const imageBaseUrl = 'https://qtzp.qhdbigdata.com/qtzp-api/upload/';
          const fullUrl = fileName.startsWith('http') ? fileName : imageBaseUrl + fileName;
          
          // 保存fileName用于提交（只存fileName，不存完整URL）
          if (field === 'projectFile') {
            this.registerForm.projectFileUrl = fileName; // 只存fileName
            this.registerForm.projectFilePreview = fullUrl; // 回显用完整路径
          } else if (field === 'legalId') {
            this.registerForm.legalIdUrl = fileName; // 只存fileName
            this.registerForm.legalIdPreview = fullUrl; // 回显用完整路径
          } else if (field === 'businessLicense') {
            this.registerForm.businessLicenseUrl = fileName; // 只存fileName
            this.registerForm.businessLicensePreview = fullUrl; // 回显用完整路径
          }
          
          console.log(`${fieldNames[field] || '文件'}上传成功，fileName:`, fileName);
        } catch (error) {
          console.error('文件上传失败:', error);
          alert(`${fieldNames[field] || '文件'}上传失败：${error.message || '未知错误'}`);
          // 上传失败，清除文件
          this.registerForm[field] = null;
          this.removeFile(field);
          return;
        }
        
        // 图片预览已在上面通过拼接完整路径设置，这里不再使用本地预览
        // 如果上传失败或需要临时预览，可以使用下面的代码
        // if (file.type.startsWith('image/')) {
        //   const reader = new FileReader();
        //   reader.onload = (e) => {
        //     this.registerForm[`${field}Preview`] = e.target.result;
        //   };
        //   reader.readAsDataURL(file);
        // } else {
        //   this.registerForm[`${field}Preview`] = '';
        // }
        
        // 重置input值，以便可以再次选择同一文件
        event.target.value = '';
      }
    },
    
    // AI客服相关方法
    showAICustomerService() {
      this.showDialog = true;
    },
    
    closeDialog() {
      this.showDialog = false;
    },
    
    sendMessage() {
      if (this.userInput.trim()) {
        // 添加用户消息
        this.chatMessages.push({
          type: 'user',
          content: this.userInput
        });
        
        // 模拟AI回复
        setTimeout(() => {
          this.chatMessages.push({
            type: 'ai',
            content: '感谢您的咨询，我会尽快为您处理这个问题。'
          });
        }, 1000);
        
        this.userInput = '';
      }
    },
    
    // 返回顶部功能
    scrollToTop() {
      // 平滑滚动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    
    // 切换用户下拉菜单
    toggleUserDropdown() {
      this.showUserDropdown = !this.showUserDropdown;
    },
    
    // 隐藏用户下拉菜单
    hideUserDropdown() {
      this.showUserDropdown = false;
    },
    
    // 跳转到个人信息页面（不受 isSoil 影响，只要登录即可查看）
    goToUserProfile() {
      this.showUserDropdown = false;
      this.$router.push('/user-profile');
    },
    goToNoticeList() {
      // if (!this.checkSoilPermission()) {
      //   return;
      // }
      this.$router.push('/notice-list');
    },
    
    // 获取未读通知数量
    async loadUnreadCount() {
      if (!this.isLoggedIn) {
        this.unreadCount = 0;
        return;
      }
      try {
        const res = await getUnreadCount();
        console.log('未读数量接口返回:', res);
        
        // 适配不同的返回格式
        let count = 0;
        if (res !== null && res !== undefined) {
          // 格式1: { code: 200, data: number } - 优先检查带 code 的格式
          if (res.code === 200 && typeof res.data === 'number') {
            count = res.data;
          }
          // 格式2: { data: number } - 没有 code 字段，但有 data
          else if (typeof res.data === 'number') {
            count = res.data;
          }
          // 格式3: 直接返回数字
          else if (typeof res === 'number') {
            count = res;
          }
          // 格式4: { count: number } 或其他字段名
          else if (typeof res.count === 'number') {
            count = res.count;
          } else if (typeof res.unreadCount === 'number') {
            count = res.unreadCount;
          }
        }
        
        this.unreadCount = count || 0;
      } catch (error) {
        console.error('获取未读数量失败:', error);
        this.unreadCount = 0;
      }
    },
    
    // 验证登录状态（通过调用用户信息接口）
    async verifyLoginStatus() {
      try {
        await this.loadUserInfo();
        // 如果成功，保持登录状态
        this.isLoggedIn = true;
        // 获取未读通知数量
        this.loadUnreadCount();
      } catch (error) {
        // 如果失败（任何错误，包括网络错误、401等），清除登录状态
        console.error('验证登录状态失败:', error);
        this.clearLoginState();
      }
    },
    // 清除登录状态（统一方法）
    clearLoginState() {
      console.log('清除登录状态');
      this.isLoggedIn = false;
      localStorage.removeItem('token');
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('isSoil');
      this.userInfo = {};
      this.showUserDropdown = false;
      this.unreadCount = 0;
      this.isSoil = true; // 重置为默认值
      
      // 同时尝试调用window上的方法（如果存在）
      if (window.updateQintuLoginStatus) {
        window.updateQintuLoginStatus(false);
      }
    },
    // 加载用户信息
    async loadUserInfo() {
      try {
        const res = await getUserInfo();
        console.log('头部-用户信息接口返回:', res);
        
        // 适配不同的返回格式
        if (res) {
          this.isSoil = res.data.isSoil;
          localStorage.setItem('isSoil', String(res.data.isSoil));
          localStorage.setItem('userId', String(res.data.userId));
          // 格式1: { user: {...} }
          if (res.user) {
            this.userInfo = res.user;
          }
          // 格式2: { code: 200, data: {...} } - 优先检查带 code 的格式
          else if (res.code === 200 && res.data) {
            this.userInfo = res.data;
          }
          // 格式3: { data: {...} }
          else if (res.data) {
            this.userInfo = res.data;
          }
          // 格式4: 直接返回用户对象
          else if (res.phonenumber || res.companyName || res.userName) {
            this.userInfo = res;
          }
          else {
            console.warn('头部-用户信息返回格式未识别:', res);
            this.userInfo = {};
          }
        } else {
          this.userInfo = {};
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.userInfo = {};
        
        // 检查是否是 401 错误（未授权）
        const is401Error = error.response && error.response.status === 401;
        // 也检查错误消息中是否包含 401 或未授权
        const isUnauthorized = error.message && (
          error.message.includes('401') || 
          error.message.includes('未授权') || 
          error.message.includes('Unauthorized')
        );
        
        // 如果是 401 错误，清除登录状态
        if (is401Error || isUnauthorized) {
          console.log('Token 已过期或无效，清除登录状态');
          this.clearLoginState();
        } else {
          // 其他任何错误（网络错误、请求失败等）也清除登录状态
          // 因为无法验证登录状态，应该视为未登录
          console.log('获取用户信息失败，清除登录状态');
          this.clearLoginState();
        }
        
        // 重新抛出错误，让调用者知道验证失败
        throw error;
      }
    },
    
    // 退出登录
    async handleLogout() {
      if (confirm('确定要退出登录吗？')) {
        try {
          await logout();
        } catch (e) {
          // 即使接口失败，也继续本地清理，避免卡死
          console.warn('调用退出登录接口失败，继续本地清理', e);
        }
        // 清除token和登录状态
        localStorage.removeItem('token');
        localStorage.removeItem('isLoggedIn');
        
        // 清除用户信息
        this.userInfo = {
        
        };
        
        // 更新登录状态
        this.isLoggedIn = false;
        this.showUserDropdown = false;
        
        // 同时尝试调用window上的方法（如果存在）
        if (window.updateQintuLoginStatus) {
          window.updateQintuLoginStatus(false);
        }
        
        // 成功提示（自动消失）
        this.successToastMessage = '退出成功';
        this.showSuccessToast = true;
        setTimeout(() => {
          this.showSuccessToast = false;
        }, 2000);
        
        // 可以跳转到首页
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      }
    },
    
    // 点击外部关闭下拉菜单
    handleClickOutside(event) {
      if (!this.$el.contains(event.target) && !event.target.closest('.user-info-wrapper')) {
        this.showUserDropdown = false;
      }
    }
  },
  
mounted() {
    // 将showLoginDialog方法挂载到window对象上，以便路由守卫调用
    window.showLoginDialog = this.showLoginDialog.bind(this);
    
    // 监听localStorage中的登录状态变化
    this.storageListener = (e) => {
      if (e.key === 'isLoggedIn') {
        // 这里可以根据需要更新组件内的登录状态
        console.log('登录状态已更新:', e.newValue === 'true');
        const newLoginStatus = e.newValue === 'true';
        if (newLoginStatus !== this.isLoggedIn) {
          this.isLoggedIn = newLoginStatus;
          if (this.isLoggedIn) {
            this.verifyLoginStatus();
          } else {
            this.clearLoginState();
          }
        }
      }
      // 也监听 token 的变化
      if (e.key === 'token') {
        const hasToken = !!e.newValue;
        if (!hasToken && this.isLoggedIn) {
          // token 被清除，但登录状态还是 true，需要清除登录状态
          console.log('Token 被清除，清除登录状态');
          this.clearLoginState();
        }
      }
    };
    window.addEventListener('storage', this.storageListener);
    
    // 初始化登录验证码
    this.fetchLoginCaptcha();

    // 从localStorage初始化登录状态
    const storedLoginStatus = localStorage.getItem('isLoggedIn') === 'true';
    const storedToken = localStorage.getItem('token');
    const storedIsSoil = localStorage.getItem('isSoil');
    
    // 初始化 isSoil 状态
    if (storedIsSoil !== null) {
      this.isSoil = storedIsSoil === 'true';
    }
    
    // 验证登录状态：必须同时有 isLoggedIn 和 token
    if (storedLoginStatus && storedToken) {
      // 验证 token 是否有效（通过调用用户信息接口）
      this.isLoggedIn = true;
      this.verifyLoginStatus();
    } else {
      // 如果没有 token 或登录状态不一致，清除登录状态
      this.isLoggedIn = false;
      if (storedLoginStatus) {
        localStorage.removeItem('isLoggedIn');
      }
      if (storedToken) {
        localStorage.removeItem('token');
      }
      // 清除 isSoil 状态
      if (storedIsSoil !== null) {
        localStorage.removeItem('isSoil');
        this.isSoil = true;
      }
    }
    
    // 添加点击外部关闭下拉菜单的事件监听
    document.addEventListener('click', this.handleClickOutside);
  },
  
  // 组件卸载前清理window对象上的方法
  beforeUnmount() {
    window.showLoginDialog = null;
    
    // 移除点击外部关闭菜单的事件监听
    document.removeEventListener('click', this.handleClickOutside);
    
    // 移除localStorage的storage事件监听
    if (this.storageListener) {
      window.removeEventListener('storage', this.storageListener);
    }
  }
};
</script>

<style scoped>
/* 引入iconfont.css */
@import url('../assets/iconfont.css');

/* 头部样式 */
.header {
  background-color: white;
  border-bottom: 2px solid #422C27;
  position: relative;
  z-index: 999;
}

.header-top {
  background-color: #f8f8f8;
  padding: 8px 0;
}

.container {
  max-width:1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.header-top-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top-left{
  color: #422C27;
  font-size: 14px;
  font-weight: bold;
}
.login-links a {
  margin-left: 18px;
  color: #422C27;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
}
.login-links a.publish-btn{
  background-color: #422C27;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  transition: all 0.3s ease;
}
.login-links a:hover {
  background-color: rgba(139, 111, 71, 0.1);
  color: #E4CEC2;
   color: #333;
  border-radius: 4px;
}
.login-links a.publish-btn:hover {
  background-color: #E4CEC2;
  color: #333;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(139, 111, 71, 0.3);
}
.login-links span{
  font-size: 14px;
}

/* 用户信息样式 */
.user-info-wrapper {
  position: relative;
  cursor: pointer;
}

.notice-icon-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  cursor: pointer;
}

.notice-icon {
  font-size: 18px !important;
  color: #422C27;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.notice-icon-wrapper:hover .notice-icon {
  background-color: rgba(66, 44, 39, 0.1);
  transform: scale(1.1);
}

.notice-badge {
  position: absolute;
  top: -2px;
  right: -5px;
  min-width: 18px;
  height: 18px;
  /* padding: 0 5px; */
  background-color: #ff4444;
  color: #ffffff;
  font-size: 10px !important;
  font-weight: bold;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #422C27;
  font-weight: bold;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.user-info:hover {
  background-color: rgba(139, 111, 71, 0.1);
}

.user-name {
  color: #422C27;
  font-weight: 600;
  font-size: 18px;
}

.user-phone {
  color: #666;
  font-size: 13px;
  font-weight: normal;
}

.dropdown-arrow {
  font-size: 12px;
  color: #666;
  transition: transform 0.3s ease;
  margin-left: 4px;
}

.arrow-up {
  transform: rotate(180deg);
}

/* 用户下拉菜单样式 */
.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-top: 8px;
  min-width: 120px;
  z-index: 1000;
  overflow: hidden;
  border: 1px solid #e9ecef;
}

.user-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.user-dropdown-item:hover {
  background: #f8f9fa;
  color: #422C27;
}

.user-dropdown-item i {
  font-size: 14px;
}

.header-main {
  padding: 20px 0;
  background:url('@/assets/bg3.png') no-repeat center center;
  background-size: cover;
  position: relative;
}


.header-main-content {
  padding-bottom: 70px;
  text-align: left;
  position: relative;
  z-index: 2;
}

/* 搜索栏定位到右侧 */
.search-section {
  position: absolute;
     right: 0;
    bottom: 0%;
}

.logo{
  position: relative;
  font-weight: bold;
  color: #fff;
}

.logo-text1{
  position: relative;
  top:16px;
  left:80px;
  font-size: 36px;
}
.logo-text3{
  position: relative;
  top:-20px;
  left:200px;
  font-size: 24px;
}
.logo-text {
  font-size: 38px;
  color: #fff;
  font-weight: bold;
  margin:30px 0 0 0;
}
.logo-text2{
  position: relative;
  top:20px;
  /* left:10px; */
  font-size: 64px;
}
.logo1{
  width:308px;
  height:100px;
  margin-top: 40px;
}

.logo2{
  width:300px;
  height:50px;
}

.search-section {
    flex: 0 0 auto;
    width: 60%;
    margin: 0;
  }
  
  /* 响应式设计 */
  @media (max-width: 1200px) {
    .main-content-row {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .search-section {
      width: 100%;
      margin-top: 20px;
    }
  }
  
  @media (max-width: 768px) {
    .logo-text {
      font-size: 24px;
    }
    
    .search-bar {
      flex-direction: column;
      gap: 10px;
    }
    
    .search-bar-left {
      width: 100%;
    }
    
    .post-btn {
      width: 100%;
      text-align: center;
    }
  }

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.search-bar-left{
  width:100%;
  display: flex;
  border: 2px solid #fff;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(255, 255, 255);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.search-dropdown {
  padding: 8px 20px 8px 12px;
  color: #333;
  background: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  border:0;
  font-weight: bold;

  appearance: none;
  cursor: pointer;
  border-right: 1px solid #eee;
}

.search-input-group {
  display: flex;
  align-items: center;
  flex: 1;
}

.search-input-group .iconfont{
  padding-left: 15px;
  font-size: 16px;
  color: #422C27;
}

.search-input {
  flex: 1;
  padding: 8px 12px;
  border: none;
  font-size: 14px;
  background-color: transparent;
  color: #333;
  outline: none;
  min-width: 0;
}

.search-input:focus {
  outline: none;
  border: none;
}

.search-input::placeholder {
  color: #422C27 !important;
}

.search-btn {
  width:100px;
  color: white;
  background-color: #422C27;
  border: none;
  padding: 8px 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.search-btn:hover {
  background-color: #E4CEC2;
  color:#333
}

.post-btn {
 
  color: #422C27;
  background: #fff;
  padding: 8px 15px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #fff;
}

.post-btn:hover {
  background-color: #E4CEC2;
  border: 1px solid #E4CEC2;
}

.search-keywords {
  display: flex;
  gap: 15px;
  margin-top: 10px;
}

.keyword {
  color: #422C27;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 8px;
  background: white;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.keyword:hover {
  background-color: #E4CEC2;
  color: #333;
  transform: translateY(-1px);
}

.main-nav{
  /* background-color: #422C27; */
  color:#422C27;
  padding-top: 14px;
  position: relative;
  z-index: 1000;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  padding: 12px 20px;  
  margin: 0 5px;
  cursor: pointer;
  position: relative;
  border-radius: 6px;
  transition: all 0.3s ease;
}
.nav-item a{
  color:#fff;
  text-decoration: none;
}
.nav-item:hover {
  background-color: #E4CEC2;
  color: #333;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.nav-item:hover a{
 background-color: #fff;
  color: #422C27!important;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
/* 下拉菜单样式 */
.nav-dropdown {
  position: relative;
}

.nav-dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
  min-width: 150px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 10000;
}

.nav-dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  list-style: none;
}

.dropdown-item a {
  display: block;
  padding: 12px 20px;
  color: #fff!important;
  text-decoration: none;
  transition: all 0.3s;
  white-space: nowrap;
}

.dropdown-item a:hover {
  background-color: #E4CEC2;
  color: #333!important;
}

.nav-item.active {
  background: #422C27;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transform: translateY(-3px);
  position: relative;
  font-weight: bold;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.nav-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px;
  height: 3px;
  /* background: #fff; */
  border-radius: 2px;
}

.new-tag-top {
  position: absolute;
  top: 0px;
  right: -30px;
  background-color: #422C27;
  color: white;
  font-size: 14px;
  padding: 2px 6px;
  width: 42px;
  line-height: 21px;
  border-radius: 10px;
  margin-left: 5px;
}

/* 右侧固定边栏 */
.fixed-sidebar {
  position: fixed;
  right: 0;
  top: 40%;
  width: 64px;
  border-radius: 10px 0px 0px 10px;
  opacity: 1;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
  z-index: 1000;
}

.fixed-item {
 padding:15px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 60px;
  font-size: 14px;
  position: relative;
}

.contact-item {
  position: relative;
}

.fixed-item:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(0,0,0,0.2);
  color: #422C27;
}
.back-top,.back-top .fixed-text{
  color:#fff;
  background-color: #422C27;
}
.fixed-item:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(0,0,0,0.2);
}

.fixed-icon {
  font-size: 20px;
  margin-bottom: 5px;
}

.fixed-text {
  font-size: 12px;
  color: #2c3e50;
  text-align: center;
}

/* 联系方式二维码悬停面板 */
.contact-qr-panel {
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 15px;
  width: 200px;
  background: #fff;
  /* border: 2px solid #d32f2f; */
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  pointer-events: none;
}

.contact-item:hover .contact-qr-panel {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  border-radius: 12px;
  transform: translateY(-50%) translateX(-5px);
}

.qr-panel-body {
  /* padding: 20px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 8px;
}

.qr-code-wrapper {
  width: 200px;
  height: 250px;
  background: #fff;
  /* border: 1px solid #e0e0e0; */
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  /* margin-bottom: 12px; */
}

.qr-code-image {
  width: 100%;
  height: 100%;

  object-fit: contain;
  border-radius: 4px;
}

.qr-panel-tip {
  font-size: 13px;
  color: #666;
  text-align: center;
  line-height: 1.5;
  margin-top: 8px;
}

/* 添加箭头指向 */
.contact-qr-panel::after {
  content: '';
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #d32f2f;
}

/* AI客服弹窗样式 */
.dialog {
  position: fixed;
  top: 0;
  right: -400px;
  width: 400px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  transition: right 0.3s ease-in-out;
}

.dialog-show {
  right: 0;
}

.dialog-content {
  position: absolute;
  top: 0;
  right: 0;
  width: 400px;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #422C27;
  color: white;
}

.dialog-title {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

.dialog-close {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-close:hover {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.dialog-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.chat-messages {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background: #f8f9fa;
}

.message {
  display: flex;
  margin-bottom: 15px;
  align-items: flex-start;
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #00aeff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
}

.message-avatar .iconfont {
  color: white;
  font-size: 18px;
}

.message-content {
  flex: 1;
  max-width: calc(100% - 130px);
  background: white;
  padding: 12px 15px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.message-content p {
  margin: 0;
  line-height: 1.4;
  color: #333;

}

.ai-message .message-content {
  background: #fff;
    text-align: left;
}

.user-message {
  flex-direction: row-reverse;
}

.user-message .message-avatar {
  background: #422C27;
  margin-right: 0;
  margin-left: 10px;
}

.user-message .message-content {
  background: #E4CEC2;
  color: #333;
  text-align: right;
  display: inline-block;
  max-width: calc(100% - 130px);
}

.chat-input {
  display: flex;
  padding: 20px;
  border-top: 1px solid #eee;
  background: white;
}

.input-field {
  flex: 1;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 20px;
  outline: none;
  font-size: 14px;
}

.input-field:focus {
  border-color: #422C27;
}

.send-btn {
  margin-left: 10px;
  padding: 12px 20px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
}

.send-btn:hover {
  background: #E4CEC2;
   color: #333;
}

/* 登录弹窗样式 */
.login-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.modal-show {
  opacity: 1;
  visibility: visible;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 650px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.auth-tabs {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.auth-tab {
  flex: 1;
  padding: 10px 0;
  text-align: center;
  cursor: pointer;
  color: #666;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
}

.auth-tab.active {
  color: #422C27;
  border-bottom-color: #422C27;
  font-weight: bold;
  background: linear-gradient(135deg, rgba(14, 133, 117, 0.1) 0%, rgba(13, 107, 95, 0.1) 100%);
  border-radius: 6px 6px 0 0;
  position: relative;
}

.auth-tab.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 3px;
  background: linear-gradient(90deg, #422C27, #0d6b5f);
  border-radius: 2px;
}

.auth-form {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

/* 两列布局样式 */
.form-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.form-row .form-group {
  flex: 1;
  margin-bottom: 0;
}

/* 适配小屏幕 */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }
  
  .form-row .form-group {
    margin-bottom: 15px;
  }
}

.form-label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
  font-weight: bold;
}

.form-require {
  display: block;
  margin-top: 2px;
  margin-bottom: 5px;
  font-size: 13px;
  color: #422C27;
  font-weight: normal;
}

.form-input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

/* 文件上传样式 */
.file-upload {
  position: relative;
  width: 100%;
}

.file-upload input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

.file-upload-label {
  display: block;
  padding: 8px;
  background-color: #f8f8f8;
  border: 1px dashed #ddd;
  border-radius: 4px;
  color: #666;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
  min-height: 24px;
  line-height: 24px;
}

/* 图片预览样式 */
.image-preview {
  margin-top: 10px;
  position: relative;
  display: inline-block;
}

.preview-image {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.remove-image-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 24px;
  height: 24px;
  background-color: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  padding: 0;
}

.remove-image-btn:hover {
  background-color: #ff7875;
}

/* 登录弹窗样式 */
.login-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

/* 注册弹窗样式 */
.register-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.modal-show {
  opacity: 1;
  visibility: visible;
}

/* 登录弹窗内容 */
.login-modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

/* 注册弹窗内容 */
.register-modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 650px;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  padding: 0;
}

/* 确保表单内容不会导致横向滚动 */
.register-modal-content .auth-form {
  width: 100%;
  box-sizing: border-box;
}

.register-modal-content .form-group {
  box-sizing: border-box;
}

.file-upload-label:hover {
  background-color: #f0f0f0;
  border-color: #422C27;
  color: #422C27;
}

.form-input:focus {
  outline: none;
  border-color: #422C27;
}

.verification-group {
  display: flex;
  gap: 10px;
}

.captcha-img {
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.verification-input {
  flex: 1;
}

.verification-btn {
  padding: 12px 15px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
}

.verification-btn:hover {
  background: #E4CEC2;
  color:#333
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  margin-right: 8px;
}

.forgot-link {
  color: #422C27;
  text-decoration: none;
  font-size: 14px;
}

.forgot-link:hover {
  text-decoration: underline;
}

.agreement-link {
  color: #422C27;
  text-decoration: none;
}

.agreement-link:hover {
  text-decoration: underline;
}

.auth-btn {
  width: 100%;
  padding: 12px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}

.auth-btn:hover {
  background: #E4CEC2;
  color:#333
}

.third-party-login {
  margin-top: 20px;
}

.divider {
  position: relative;
  text-align: center;
  margin: 20px 0;
}

.divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #eee;
}

.divider-text {
  background: white;
  padding: 0 15px;
  color: #999;
  font-size: 14px;
}

.third-party-buttons {
  display: flex;
  gap: 10px;
}

.third-party-btn {
  flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.third-party-btn:hover {
  background: #f8f9fa;
}

.wechat-btn {
  color: #07c160;
}

.qq-btn {
  color: #12b7f5;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 20px;
  }
  
  .third-party-buttons {
    flex-direction: column;
  }
  
  .dialog {
    width: 100%;
    right: -100%;
  }
  
  .dialog-content {
    width: 100%;
  }
  
  .fixed-sidebar {
    display: none;
  }
}

/* 发布土方弹窗样式 */
.publish-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 20px;
}

.publish-modal-container {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 1200px;
  max-height: 95vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.publish-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
  flex-shrink: 0;
}

.publish-modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 20px;
}

.publish-modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.publish-modal-content .land-supply-page {
  margin: 0;
  padding: 20px;
  background: white;
}

.publish-modal-content .container {
  padding: 0;
}

/* 登录成功提示框样式 */
.success-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  pointer-events: none;
}

.toast-content {
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  min-width: 150px;
  justify-content: center;
}

.toast-icon {
  font-size: 20px;
  color: #4caf50;
  font-weight: bold;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: rgba(76, 175, 80, 0.2);
  border-radius: 50%;
  flex-shrink: 0;
}

.toast-message {
  font-size: 16px;
  font-weight: 500;
}

/* 提示框淡入淡出动画 */
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s ease;
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
}

.publish-modal-content .form-wrapper {
  margin: 0;
  box-shadow: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .publish-modal {
    padding: 10px;
  }

  .publish-modal-container {
    width: 95%;
    max-height: 98vh;
  }

  .publish-modal-content {
    padding: 10px;
  }
}

/* 联系电话图片弹窗样式 */
.contact-image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.contact-image-modal.modal-show {
  opacity: 1;
  visibility: visible;
}

.contact-image-modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.contact-image-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
  flex-shrink: 0;
}

.contact-image-title {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.contact-image-body {
  flex: 1;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
}

.contact-image {
  max-width: 100%;
  max-height: 70vh;
  width: auto;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .contact-image-modal-content {
    width: 95%;
    max-width: 95%;
  }

  .contact-image {
    max-height: 60vh;
  }
}
</style>